<template>
  <nav class="navbar navbar-default">
    <div class="container-fluid">
      <div class="navbar-minimize">
        <button class="btn btn-fill btn-icon" @click="minimizeSidebar">
          <i :class="$sidebar.isMinimized ? 'ti-menu-alt' : 'ti-more-alt'"></i>
        </button>
      </div>
        <div class="navbar-right">
     
        <form class="navbar-form navbar-left navbar-search-form" role="search" @submit.prevent.native="checkEnter" v-on:submit.prevent="search">
          <label><small>Search: &nbsp;&nbsp;&nbsp;&nbsp;</small></label>
        
        <el-select class=""
                           size="small"
                           placeholder="Find"
                           v-model="selectedBase"
                           @change="setBase(selectedBase)">
                  <el-option v-for="option in searchBase"
                             class="select-danger"
                             :value="option.value"
                             :label="option.label"
                             :key="option.label">
                  </el-option>
                </el-select>
                   <el-select class=""
                           size="small"
                           placeholder="By"
                           v-model="selectedProperty"
                           no-data-text="Select Term First!"
                           >
                  <el-option v-for="option in searchItem"
                             class="select-danger"
                             :value="option.value"
                             :label="option.label"
                             :key="option.label">
                  </el-option>
                </el-select>
        
          <div class="input-group">
            <input type="text" value="" v-model="selectedValue" @keyup.enter="search" class="form-control input-sm" placeholder="Search Term">
            <span class="input-group-addon"><i class="fa fa-search"></i></span>
          </div>
          <button class="btn btn-sm" @click="search">Go </button>
        </form>
     
      </div>
      <div class="navbar-header">
        <button type="button" class="navbar-toggle" :class="{toggled: $sidebar.showSidebar}" @click="toggleSidebar">
          <span class="sr-only">Toggle navigation</span>
          <span class="icon-bar bar1"></span>
          <span class="icon-bar bar2"></span>
          <span class="icon-bar bar3"></span>
        </button>
        <a class="navbar-brand">{{this.$route.name}} </a>
      </div>
    
    </div>
  </nav>
</template>
<script>
  import { Select} from 'element-ui'
  export default {
    components:{
      [Select.name]: Select
    },
    data () {
      return {
        activeNotifications: false,
        searchBase:[{value: 'Customer', label: 'Customer'}],
        searchProperty:{
          Customer:[{value:"id",label:"By ID"},{value:"lastname",label:"By surname"},{value:"firstname",label:"By first name"},{value:"email",label:"By email"}],
        
        },
        searchItem:{},
        selectedBase:'',
        selectedProperty:'',
        selectedValue:''
      }
    },
    computed:{

        partner(){
          const token = localStorage.getItem('vuex')
          const parsed = JSON.parse(token)
          const partner = parsed['auth']['partner']
          return partner
        }
    },

    methods: {
      setBase (term) {
this.searchItem=this.searchProperty[this.selectedBase]
      },
search (){
this.$router.push('/'+this.selectedBase+'/'+this.selectedProperty+'/'+this.selectedValue)
},

      capitalizeFirstLetter (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      toggleNotificationDropDown () {
        this.activeNotifications = !this.activeNotifications
      },
      closeDropDown () {
        this.activeNotifications = false
      },
      toggleSidebar () {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      hideSidebar () {
        this.$sidebar.displaySidebar(false)
      },
      minimizeSidebar () {
        this.$sidebar.toggleMinimize()
      }
    }
  }

</script>
<style>
.select-danger.el-select .el-input input {
    border-color: #e8e7e3 !important;
    background-color: #F3F2EE;
    border: 1px solid #e8e7e3;
    border-radius: 4px;
    color: #66615b;
    font-size: 14px;
    padding: 7px 18px;
    height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/TopNavbar.vue